import { render } from "./OAuthAuthorizationCode.vue?vue&type=template&id=3d6bcbef&scoped=true"
import script from "./OAuthAuthorizationCode.vue?vue&type=script&lang=js"
export * from "./OAuthAuthorizationCode.vue?vue&type=script&lang=js"

import "./oauth-authorize.scss?vue&type=style&index=0&id=3d6bcbef&scoped=true&lang=scss"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6bcbef"]])

export default __exports__